<template>
  <div>
    <div v-if="dataPage.route=='accueil'" class="accueil">
        
        <!-- HOME CAROUSEL -->
        <b-carousel
        id="carouselHome"
        :interval="6000"
        background="#121738"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333;"
        >
            <div class="carousel-caption h-100 d-flex align-items-center flex-column justify-content-center">
                <div class="container">
                    <h1>Fabricant <strong>d'appareillages orthodontiques</strong> pour les professionnels de la
                        santé dentaire.</h1>
                    <h2>De la pédodontie à la récidive adulte.</h2>
                </div>
            </div>
            <b-carousel-slide img-src="photos/slide-home-laboratoire-tournier-01.jpg">
            </b-carousel-slide>
            <b-carousel-slide img-src="photos/slide-home-laboratoire-tournier-02.jpg">
            </b-carousel-slide>
            <b-carousel-slide img-src="photos/slide-home-laboratoire-tournier-03.jpg">
            </b-carousel-slide>
            <div class="next">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-down" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                        d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" />
                </svg>
            </div>
        </b-carousel>


        <!-- CONTENT-->
        <div id="presentation" class="bg-3">
            <div class="container py-4">
                <div class="row">
                    <div class="col-md-7">
                        <h2>Hélène & Jean-Baptiste TOURNIER</h2>
                        <p>Le laboratoire d’orthodontie TOURNIER, situé à Rouen en Normandie est à la disposition des
                            professionnels de la santé pour la réalisation de tous types d’orthèses dentaires en
                            orthodontie, pédodontie et ODF.</p>

                        <p>Equipé des dernières technologies, nous travaillons à partir d’empreintes physiques ou
                            numériques.</p>

                        <!-- <p>Nous attachons particulièrement une grande importance à la qualité de nos orthèses et nous
                            les réalisons à la main dans notre laboratoire ouvert aux professionnels. Pour faciliter
                            l’adaptation en bouche, ils sont travaillons sur des empreintes en platre que nous
                            produisons à partir de vos scans.<br>
                            Notre priorité est de vous faire gagner du temps en cabinet et d’obtenir la satisfaction
                            totale de vos patients.</p> -->
                    </div>
                    <div class="col-md-5">
                        <div id="boost" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#carouselPresentation" data-slide-to="0" class="active"></li>
                                <li data-target="#carouselPresentation" data-slide-to="1"></li>
                                <li data-target="#carouselPresentation" data-slide-to="2"></li>
                            </ol>
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img class="d-block w-100" src="@/../public/photos/photo-jb-tournier.jpg" alt="First slide">
                                </div>
                                <div class="carousel-item">
                                    <img class="d-block w-100" src="@/../public/photos/photo-jb-tournier.jpg" alt="First slide">
                                </div>
                                <div class="carousel-item">
                                    <img class="d-block w-100" src="@/../public/photos/photo-jb-tournier.jpg" alt="First slide">
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carouselPresentation" role="button"
                                data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselPresentation" role="button"
                                data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- SAVOIR PLUS -->
            <div class="container">
                <div class="savoir-plus d-flex align-items-center justify-content-start">
                    <router-link tag="a" to="le-laboratoire" class="d-flex align-items-center justify-content-between c-1">En savoir plus
                        <img src="@/../public/elements/lt-arrow-right-moutarde.svg">
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="dataPage.route=='contact'" class="bg-3">
        <div class="position-relative">
            <!-- CARTE INTERACTIVE -->
            <iframe frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.openstreetmap.org/export/embed.html?bbox=1.0951218008995058%2C49.437125614849855%2C1.0973748564720156%2C49.438405835443405&amp;layer=mapnik&amp;marker=49.437765729324006%2C1.0962483286857605"></iframe>
            <!-- FLECHE -->
            <div class="next">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-down" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                        d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" />
                </svg>
            </div>
        </div>
        <div id="form" class="bg-3">
            <div class="container py-4">
                <section class="mb-4">

                    <!--Section heading-->
                    <div class="row" v-if="formContact.send">
                        <div class="col-md-12 flex center text-center mt-2 mb-2 form-send">

                            <h2 class="h1-responsive font-weight-bold text-center my-4">Merci</h2>
                            <feather-icon class="m-0"  icon='CheckCircleIcon' svgClasses='widthCheck' style="" />
                            
                            <p>    
                                Votre email a été correctément envoyé<br>
                                Nous vous répondrons dans les meilleurs délais
                            </p>
                        </div>
                    </div>
                    <div  v-else>
                        <h2 class="h1-responsive font-weight-bold text-center my-4">Contactez-nous</h2>
                        <!--Section description-->
                        <p class="text-center w-responsive mx-auto mb-5">Vous avez une question ? N'hésitez pas à nous contacter, nous reviendrons vers vous rapidement.</p>

                        <div class="row">

                            <!--Grid column-->
                            <div class="col-md-9 mb-md-0 mb-5">
                                
                                <form id="contact-form" name="contact-form">

                                    <!--Grid row-->
                                    <div class="row">

                                        <!--Grid column-->
                                        <div class="col-md-6">
                                            <div class="md-form mb-0">
                                                <input type="text" placeholder="Votre Nom" id="formContactNom" name="lastname"
                                                    class="form-control" v-validate="'required'" v-model="formContact.dataForm.lastname"  data-vv-validate-on="blur">
                                                <label for="formContactNom" class=""></label>
                                                <span class="text-danger text-sm" v-show="errors.has('lastname')">{{ errors.first('lastname') }}</span>
                                            </div>
                                        </div>
                                        <!--Grid column-->

                                        <!--Grid column-->
                                        <div class="col-md-6">
                                            <div class="md-form mb-0">
                                                <input type="text" placeholder="Votre Prénom" id="formContactPrenom" name="firstname"
                                                    class="form-control" v-validate="'required'" v-model="formContact.dataForm.firstname"  data-vv-validate-on="blur">
                                                <label for="formContactPrenom" class=""></label>
                                                <span class="text-danger text-sm" v-show="errors.has('firstname')">{{ errors.first('firstname') }}</span>
                                            </div>
                                        </div>
                                        <!--Grid column-->

                                    </div>
                                    <!--Grid row-->

                                    <!--Grid row-->
                                    <div class="row">

                                        <!--Grid column-->
                                        <div class="col-md-6">
                                            <div class="md-form mb-0">
                                                <input type="text" placeholder="Votre adresse e-mail" id="formContactEmail" name="email"
                                                    class="form-control" v-validate="'required'" v-model="formContact.dataForm.email"  data-vv-validate-on="blur">
                                                <label for="formContactEmail" class=""></label>
                                                <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                                            </div>
                                        </div>
                                        <!--Grid column-->

                                        <!--Grid column-->
                                        <div class="col-md-6">
                                            <div class="md-form mb-0">
                                                <input type="text" placeholder="Votre numéro de téléphone" id="formContactTelephone" name="phone"
                                                    class="form-control" v-model="formContact.dataForm.phone"  data-vv-validate-on="blur">
                                                <label for="formContactTelephone" class=""></label>
                                                <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                                            </div>
                                        </div>
                                        <!--Grid column-->

                                    </div>
                                    <!--Grid row-->

                                    <!--Grid row-->
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="md-form mb-0">
                                                <input type="text" id="formContactObjet" placeholder="L'objet de votre message"
                                                    class="form-control" v-validate="'required'" name="objet" v-model="formContact.dataForm.details[0].details[0].value"  data-vv-validate-on="blur">
                                                <label for="formContactObjet" class=""></label>
                                            </div>
                                        </div>
                                    </div>
                                    <!--Grid row-->

                                    <!--Grid row-->
                                    <div class="row">

                                        <!--Grid column-->
                                        <div class="col-md-12">

                                            <div class="md-form">
                                                <textarea type="text" id="formContactMessage" placeholder="Votre message" name="message"
                                                    rows="4" class="form-control md-textarea" v-validate="'required'" v-model="formContact.dataForm.details[0].details[1].value"  data-vv-validate-on="blur" ></textarea>
                                                <label for="formContactMessage"></label>
                                                <span class="text-danger text-sm" v-show="errors.has('message')">{{ errors.first('message') }}</span>
                                            </div>

                                        </div>
                                    </div>
                                    <!--Grid row-->

                                    <div class="row">
                                        <div class="col-md-7 col-sm-12">
                                            <vue-recaptcha ref="recaptcha" class="mb-4" @verify="onVerify" sitekey="6LfXVTcaAAAAAN271jFMOjRYUObjjWabyFc9WdEo">
                                            </vue-recaptcha>
                                        </div>
                                        <div class="col-md-5 col-sm-12  text-center text-md-right">
                                            <a class="btn bg-1 c-3" @click.prevent="submitForm">Envoyer</a>
                                        </div>
                                    </div>
                                </form>
                                <hr class="d-md-none mt-4" />
                                <!-- 
                                <div class="text-center text-md-left">
                                    <a class="btn bg-1 c-3"
                                        onclick="document.getElementById('contact-form').submit();">Envoyer</a>
                                </div> -->
                                <div class="status"></div>
                            </div>
                            <!--Grid column-->

                            <!--Grid column-->
                            <div class="col-md-3 text-center">
                                <ul class="list-unstyled mb-0">
                                    <li class="d-flex flex-column justify-content-center align-items-center"><img src="@/../public/elements/lt-icone-pin-violet.svg">
                                        <p>7 rue de la République<br>76000 ROUEN</p>
                                    </li>

                                    <li class="d-flex flex-column justify-content-center align-items-center"><img src="@/../public/elements/lt-icone-phone-violet.svg">
                                        <a href="tel:0676124578">06 76 12 45 78</a>
                                    </li>

                                    <li class="mt-3 d-flex flex-column justify-content-center align-items-center"><img src="@/../public/elements/lt-icone-email-violet.svg">
                                        <p>laboratoiretournier@gmail.com</p>
                                    </li>
                                </ul>
                            </div>
                            <!--Grid column-->

                        </div>
                    </div>

                </section>

            </div>
        </div>
    </div>
    <div v-else>
        <div id="pre-content" 
            v-if="dataPageInfos.urlPictureHeader"
            :style="{ 'background-image': 'url('+ dataPageInfos.urlPictureHeader + ')' }"
            style="background-size:cover !important; background-position: center !important; background-repeat:no-repeat !important"
        >
            <div class="container">
                <div class="title-page">
                    <div>
                        <h2>{{dataPage.title}}</h2>
                        <h4 v-if="dataPage.subTitle">{{dataPage.subTitle}}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div id="pre-content" v-else  style="background: url('photos/slide-home-laboratoire-tournier-01.png'); background-size:cover !important; background-position: center !important; background-repeat:no-repeat !important">
            <div class="container">
                <div class="title-page">
                    <div>
                        <h2>{{dataPage.title}}</h2>
                        <h4 v-if="dataPage.subTitle">{{dataPage.subTitle}}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <v-style>
        /*
            Use CustomerVar with example : {{customizableVar1}}
            Set Background Image with example : background-image:url('\{\{require('@/html/elements/after-page-title-0f555d.svg')}}') !important;
        */      
    </v-style>
    <div class="position-relative pb-5 pt-5" :class="(dataPage.route=='contact' ? 'bg-3' : '')" :style="(dataPage.route=='accueil' ? 'padding-top:90px !important' :'')">
        <div class="parallax-abstract"  v-if="dataPage.route=='accueil'">
        </div>
        <div class="parallax-abstract-top"  v-else-if="dataPage.route!=='contact'" >
        </div>
        <div class="container pb-5 pt-5">

            <!-- GENERE CI-DESSOUS LE PAGE BUILDER EN APERCU SEUL -->
            <div
                class="item noEditMode"
                v-for="(item, index) in layout"
                :key="index"
            >
                <row-widget
                    v-if="item.type == 'row'"
                    :layout="layout"
                    :preview="preview"
                    :contenteditable="contenteditable"
                    :item="item"
                    :itemIndex="index"
                    class="mb-2"
                    ></row-widget>
                <col-widget
                v-if="item.type == 'col'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                ></col-widget>
                <text-widget
                v-if="item.type == 'text'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :themeColors="themeColors"
                ></text-widget>
                <text-area-widget
                v-if="item.type == 'content'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                ></text-area-widget>
                <image-widget
                v-if="item.type == 'image'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                ></image-widget>
                <alert-widget
                v-if="item.type == 'alert'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :color="item.color"
                >
                </alert-widget>
                <button-widget
                v-if="item.type == 'button'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                >
                </button-widget>
                <link-widget
                v-if="item.type == 'link'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                >
                </link-widget>
                <title-widget
                v-if="item.type == 'title'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                ></title-widget>
                <quote-widget
                v-if="item.type == 'quote'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                ></quote-widget>
            </div>  
            <!-- FIN GENERATOR -->          
        </div>
    </div>
  </div>
</template>
<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";
import { setSubCollection, setSub2Collection } from "@/../script/global";
import axios from "axios";
import dayjs from "dayjs";
// CONFIG
import  { themeConfig, irisConfig }  from "@/../siteConfig.js";

// SPECIFIC TO PAGEBUILDER 
import RowWidget from "../editor/RowWidget";
import ColWidget from "../editor/ColWidget";
import TextWidget from "../editor/TextWidget";
import TextAreaWidget from "../editor/TextAreaWidget";
import ImageWidget from "../editor/ImageWidget";
import AlertWidget from "../editor/alertWidget";
import ButtonWidget from "../editor/ButtonWidget";
import LinkWidget from "../editor/LinkWidget";
import TitleWidget from "../editor/TitleWidget";
import QuoteWidget from "../editor/QuoteWidget";
import { GridLayout, GridItem } from "vue-grid-layout";

// SPECIFIC FOR CONTACT
import VueRecaptcha from 'vue-recaptcha';
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    lastname: {
      required: 'Veuillez saisir votre nom',
    },
    firstname: {
      required: 'Veuillez saisir votre prénom',
    },
    phone: {
      required: 'Veuillez saisir votre numéro de téléphone',
    },
    email: {
      required: 'Veuillez saisir votre adresse email',
    },
    objet: {
      required: 'Veuillez saisir l\'objet de votre message',
    },
    message: {
      required: 'Veuillez saisir votre message',
    }
  }
}
Validator.localize('fr', dict)

export default {
  components: { 
    RowWidget,
    ColWidget,
    TextWidget,
    TextAreaWidget,
    ImageWidget,
    AlertWidget,
    ButtonWidget,
    LinkWidget,
    TitleWidget,
    QuoteWidget,
    VueRecaptcha,
  },
  name: "page-view",
  props: {
    dataPage:{
        type: Object
    },
  },
  data() {
    return {
        contenteditable: false,
        preview: true,
        irisConfig:irisConfig,

        // DATA objet pour instancier la collection Leads sur la Dashboard
        formContact:{
            dataForm:{
                lastname: '',
                firstname: '',
                phone: '',
                email: '',
                details:[
                    {
                        icon:"",
                        label:"Détails du message",
                        details:[
                            {
                                label:"Objet",
                                value:""
                            },
                            {
                                label:"Message",
                                value:""
                            }
                        ]
                        
                    }
                ],
                status:"Non traité",
                addDate:new Date()
            },
            robot: false,
            send:false
        },
        // DATA  pour générer la map OpenStreet
        map: null,
        tileLayer: null,
        mapMarker: [{
            id: 0,
            name: '<b>LABORATOIRE TOURNIER</b><br>Rue de la république<br>76000 Rouen',
            type: 'marker',
            coords: [49.475604, 1.129772],
        }],
    };
  },
  computed:{
    dataPageInfos: function () {
        if(this.dataPage){
            return this.dataPage || ""
        }else{
            return ""
        }
    },
    layout: function () {
        if(this.dataPage.gridLayout.length > 0){
            return this.dataPage.gridLayout || ""
        }else{
            return ""
        }
    },
    color1: function () {
        if(this.dataPage.customizableVar[0].selectItems[0].value){
            return this.dataPage.customizableVar[0].selectItems[0].value
        }else{
            return "0f555d"
        }
    },
    color2: function () {
        if(this.dataPage.customizableVar[0].selectItems[1].value){
            return this.dataPage.customizableVar[0].selectItems[1].value
        }else{
            return "0f555d"
        }
    },
    color3: function () {
        if(this.dataPage.customizableVar[0].selectItems[2].value){
            return this.dataPage.customizableVar[0].selectItems[2].value
        }else{
            return "0f555d"
        }
    },
    customizableVar1: function () {
        if(this.dataPage.customizableVar[0].value.value){
            return this.dataPage.customizableVar[0].value.value
        }else{
            return "0f555d"
        }
    },
    urlPictureHeader: function () {
        if(this.dataPage.urlPictureHeader){
            return this.dataPage.urlPictureHeader
        }else{
            return '' // Ajouter  pour définir une image par défaut :  require('@/html/elements/bg-header.jpg')
        }
    },
  },
  mounted() {
    // On verifi si la page est la page contact afin d'initialiser la map
    this.checkPageContact()


  },
  watch: {
    dataPage (newData, old) {
        // On regarde si la route a changée
        //console.log("Ancienne route : ", old, "Nouvelle route : ", newData)
        this.checkPageContact()
    }
  },
  methods: { 
    checkPageContact() {
        if(this.dataPage.id=="QsKFEBPCq9ujZckvVv9S"){
            setTimeout(() => {
                this.initMap();
                this.initMarkers();
            }, 500);
        }else{
            if(this.map){
                this.map.remove();
            }
        }
    },
    
    // Methodes pour la page contact Form et Map
    submitForm() {
        if (this.formContact.robot) {
            this.$validator.validateAll().then(result => {
                if(result) {
                    this.formContact.send = true
                    this.sendMail()
                    setSub2Collection(
                        "customers",
                        this.irisConfig.customers,
                        "sites",
                        this.irisConfig.sites,
                        "leads",
                        this.formContact.dataForm,
                    );
                }else{
                }
            })
        }
    },
     
    sendMail() {
      // ENVOI DU MAIL
      var data = new FormData();

      data.set("to", "laboratoiretournier@gmail.com");
      data.set("cci", "contact@devinfluence.fr");
     
      data.append("customer", 'LABORATOIRE TOURNIER');
      data.append("website", 'www.laboratoire-tournier.fr');
      data.append("lastname", this.formContact.dataForm.lastname);
      data.append("firstname", this.formContact.dataForm.firstname);
      data.append("phone", this.formContact.dataForm.phone);
      data.append("email", this.formContact.dataForm.email);
       data.append(
        "details",
        JSON.stringify(this.formContact.dataForm.details)
      );
      data.append("date", dayjs().format("DD/MM/YYYY"));
      data.append("hours", dayjs().format("HH"));
      data.append("minutes", dayjs().format("mm"));
      axios({
        method: "post",
        url: "https://app.orisis.fr/api-email.php?request=emailFromWebSiteForm",
        data: data,
      })
        .then(function(reponse) {
          //On traite la suite une fois la réponse obtenue
          console.log(reponse);
        })
        .catch(function(erreur) {
          //On traite ici les erreurs éventuellement survenues
          console.error(erreur);
        });
    },
    onVerify: function (response) {
      if (response) this.formContact.robot = true;
    },
    initMarkers() {
      this.mapMarker.forEach((mapMarkerData) => {
            var marker = L.marker(mapMarkerData.coords).addTo(this.map);
            marker.bindPopup(mapMarkerData.name).openPopup();
      });
    },
    initMap() {
      this.map = L.map('mapid').setView([49.475604, 1.129772], 16);
      this.tileLayer = L.tileLayer(
        'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
        {
          maxZoom: 18,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
        }
      );
      this.tileLayer.addTo(this.map);
    },
  }

    
};
</script>
